import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
  },
  label: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
  },
  editor: {
    backgroundColor: theme.palette.common.white,
    '& .ql-toolbar': {
      borderTopLeftRadius: 4,
      borderTopRightRadius: 4,
    },
    '& .ql-container': {
      minHeight: 280,
      borderBottomLeftRadius: 4,
      borderBottomRightRadius: 4,
      fontSize: '1rem',
    },
    '& .ql-editor': {
      minHeight: 280,
    },
  },
}))

export { useStyles }
